var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"checkout-h3 pb-3"},[_vm._v("Resumo do seu Pedido #"+_vm._s(_vm.eventID)+" - "+_vm._s(_vm.$route.name === 'commissioner' && _vm.orderPdvData ? _vm.orderPdvData.codigo : _vm.orderID))])])}
var staticRenderFns = []

export { render, staticRenderFns }